<template>
  <e-dialog
    :value="value"
    content-class="popup-listing-library"
    fill-height
    title="Past Listing"
    @close="hide"
  >
    <template slot="title-actions">
      <v-btn
        depressed
        color="primary"
        class="mr-4 rounded-lg"
        target="_blank"
        nuxt
        to="/manage-analytics/listings"
      >
        Manage Listings
      </v-btn>
    </template>

    <v-layout column class="flex-0-0 pt-5 mx-5">
      <v-layout v-if="actionNote && actionNote.title" column class="mb-5 pa-3 rounded-lg bg-action-note">
        <h5 class="grey--text text--darken-1 text-subtitle-2 font-weight-semibold">
          {{ actionNote.title }}
        </h5>
        <p class="mb-0 grey--text text--darken-1 action-note-desc">
          {{ actionNote.description }}
        </p>
      </v-layout>

      <v-layout class="mb-1">
        <e-search
          v-model="keyword"
          placeholder="Search by address, city or ZIP"
          class="mr-3 w-full"
          @input="fetchData"
        />
        <v-btn
          large
          depressed
          color="primary"
          class="rounded-lg"
          @click="showPopupAddEditListing = !showPopupAddEditListing"
        >
          <v-icon class="mr-2">
            add
          </v-icon>
          Add a Listing
        </v-btn>
      </v-layout>
      <v-layout wrap class="align-center">
        <!-- Filter Type -->
        <v-select
          v-model="filter.type"
          :class="[$helpers.ensureArray(filter.type).length ? 'primary--text': 'grey--text text--darken-4']"
          :items="$helpers.ensureArray(options.types)"
          :menu-props="{ bottom: true, offsetY: true, minWidth: '259px' }"
          :style="{ width: '90px' }"
          append-icon=""
          class="mt-1 mr-1 flex-0-0 text-subtitle-2 btn-filter"
          dense
          hide-details
          multiple
          outlined
          prefix="Type"
          @change="fetchData"
        >
          <template #selection="{ index }">
            <span v-if="index === 0" class="primary--text">
              : {{ filter.type.length }}
            </span>
          </template>
        </v-select>
        <!-- Filter Home type -->

        <v-select
          v-model="filter.homeType"
          :class="[$helpers.ensureArray(filter.homeType).length ? 'primary--text': 'grey--text text--darken-4']"
          :items="$helpers.ensureArray(options.homeTypes)"
          :menu-props="{ bottom: true, offsetY: true, minWidth: '259px' }"
          :style="{ width: '140px' }"
          append-icon=""
          class="mt-1 mr-1 flex-0-0 text-subtitle-2 btn-filter"
          dense
          hide-details
          multiple
          outlined
          prefix="Home Type"
          @change="fetchData"
        >
          <template #selection="{ index }">
            <span v-if="index === 0" class="primary--text">
              : {{ filter.homeType.length }}
            </span>
          </template>
        </v-select>
        <!-- Filter Price -->
        <ERangeSlider
          :min="0"
          :max="900000"
          title="Price"
          prefix="$"
          @change="updateFilter('price', $event)"
        >
          <v-btn
            slot="selection"
            large
            outlined
            depressed
            :ripple="false"
            class="mt-1 mr-1 pl-3 text-subtitle-2 btn-filter"
          >
            {{ filter.price.length ? formatRange(filter.price, '$') : 'Price' }}
          </v-btn>
        </ERangeSlider>
        <!-- Filter Bedroom -->
        <ERangeSlider
          :min="0"
          title="Bedrooms"
          @change="updateFilter('bedroom', $event)"
        >
          <v-btn
            slot="selection"
            large
            outlined
            depressed
            :ripple="false"
            class="mt-1 mr-1 pl-3 text-subtitle-2 btn-filter"
          >
            {{ filter.bedroom.length ? `Bedrooms: ${formatRange(filter.bedroom)}` : 'Bedrooms' }}
          </v-btn>
        </ERangeSlider>
        <!-- Filter Bathroom -->
        <ERangeSlider
          :min="0"
          title="Bathrooms"
          @change="updateFilter('bathroom', $event)"
        >
          <v-btn
            slot="selection"
            large
            outlined
            depressed
            :ripple="false"
            class="mt-1 mr-1 pl-3 text-subtitle-2 btn-filter"
          >
            {{ filter.bathroom.length ? `Bathrooms: ${formatRange(filter.bathroom)}` : 'Bathrooms' }}
          </v-btn>
        </ERangeSlider>
        <!-- Filter Square feet -->
        <ERangeSlider
          :min="0"
          :max="7500"
          title="Square Feet"
          @change="updateFilter('squareFeet', $event)"
        >
          <v-btn
            slot="selection"
            large
            outlined
            depressed
            :ripple="false"
            class="mt-1 mr-1 pl-3 text-subtitle-2 btn-filter"
          >
            {{ filter.squareFeet.length ? `Square Feet: ${formatRange(filter.squareFeet)}` : 'Square Feet' }}
          </v-btn>
        </ERangeSlider>
        <!-- Filter Tags -->
        <div class="mt-1">
          <PopupTagFilter
            v-model="filter.tags"
            type="content"
            category="Listing"
            class="btn-filter"
            btn-classes="pl-3 text-subtitle-2 btn-filter"
            @input="fetchData"
          >
            <template slot="btn-filter">
              Tags<span v-if="filter.tags.length" class="primary--text">
                : {{ filter.tags.length }}
              </span>
            </template>
          </PopupTagFilter>
        </div>
      </v-layout>
    </v-layout>

    <v-layout v-if="!isLoading" column class="overflow-y-auto">
      <v-layout v-if="listings.length" wrap class="flex-0-0 pa-3">
        <v-flex
          v-for="(listing, lIdx) in listings"
          :key="lIdx"
          xs4
          class="pa-2"
        >
          <v-layout
            column
            class="h-full border border-solid position-relative rounded-lg overflow-hidden listing-item"
            :class="choseItems.some(ci => ci._id === listing._id) ? 'listing-selected border-primary' : 'border-secondary'"
          >
            <div class="position-absolute absolute-0-0 selected-icon">
              <img src="~/assets/images/icon/status-selected.png">
            </div>
            <div class="position-absolute absolute-0-0">
              <img v-if="selectedIds.includes(listing._id)" src="~/assets/images/icon/status-disabled.png">
            </div>

            <ESlider :images="listing.images" image-key="" />

            <v-layout column class="pa-2 cursor-pointer" @click="chooseListing(listing)">
              <v-flex class="d-flex flex-0-0 align-center">
                <v-icon class="material-icons-outlined mr-1">
                  place
                </v-icon>
                <span class="grey--text text--darken-1 text-address">
                  {{ listing | addressInfo }}
                </span>
              </v-flex>
              <p class="flex-0-0 mb-2 text-title">
                {{ listing.title }}
              </p>

              <v-flex class="flex-0-0 mb-3">
                <span v-for="(info, iIdx) in roomInfo(listing)" :key="lIdx+'_'+iIdx">
                  <v-icon
                    v-if="iIdx !== 0"
                    class="mx-2 material-icons-round"
                    color="grey darken-4"
                    size="6"
                  >
                    fiber_manual_record
                  </v-icon>
                  <span class="text-room">
                    {{ info }}
                  </span>
                </span>
              </v-flex>
              <v-spacer />

              <v-flex class="d-flex flex-0-0 align-center">
                <v-chip x-small color="orange darken-3" class="mr-2 px-1 rounded white--text">
                  <span class="text-type">{{ listing.listingType }}</span>
                </v-chip>
                <span class="text-h5 accent--text">{{ listing.price | formatCurrency }}</span>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout v-else column class="flex-center">
        <div class="text-center">
          <img src="~/assets/images/no-content.png" width="50%">
        </div>
        <p class="mb-6 text-subtitle-1 grey--text text--darken-1 text-center">
          <template v-if="$slots['help-text']">
            <slot name="help-text" />
          </template>
          <template v-else>
            No listings created
          </template>
        </p>
        <v-btn
          large
          depressed
          color="primary"
          class="px-5 rounded-lg"
          @click="showPopupAddEditListing = !showPopupAddEditListing"
        >
          <v-icon class="mr-2">
            add
          </v-icon>
          Add a Listing
        </v-btn>
      </v-layout>
    </v-layout>

    <template v-if="multiple" slot="actions">
      <p v-if="choseItems.length" class="my-auto text-subtitle-2">
        {{ choseItems.length }} listings selected
      </p>
      <v-spacer />
      <v-btn
        large
        outlined
        color="primary"
        class="px-5 rounded-lg"
        @click="hide"
      >
        Cancel
      </v-btn>
      <v-btn
        large
        depressed
        color="primary"
        class="px-5 rounded-lg"
        @click="save"
      >
        Choose
      </v-btn>
    </template>

    <PopupAddEditListing v-model="showPopupAddEditListing" @save="afterSaved" />
  </e-dialog>
</template>

<script>
import PopupTagFilter from '../../stream/popups/popup.filter-tags.vue'
import PopupAddEditListing from './popup.add-edit.vue'
import ERangeSlider from '@/plugins/components/e-range-slider.vue'
import ESlider from '@/plugins/components/e-slider.vue'
import { addressInfo, roomInfo } from '@/utils/listing'

export default {
  name: 'PopupListingLibrary',

  components: {
    ERangeSlider,
    ESlider,
    PopupTagFilter,
    PopupAddEditListing
  },

  filters: {
    addressInfo
  },

  props: {
    value: {
      type: Boolean,
      required: true
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    autoChoose: Boolean, // auto choose & emit when create new listing
    multiple: Boolean,
    actionNote: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    isLoading: false,
    listings: [],
    choseItems: [],
    keyword: '',
    options: {
      homeTypes: [
        { text: 'House', value: 'house' },
        { text: 'Townhomes', value: 'townhomes' },
        { text: 'Multi-family', value: 'multi-family' },
        { text: 'Condos/Co-ops', value: 'condos-co-ops' },
        { text: 'Lots/Land', value: 'lots-land' },
        { text: 'Apartments', value: 'apartments' },
        { text: 'Manufactured', value: 'manufactured' }
      ]
    },
    filter: {
      price: [],
      bedroom: [],
      bathroom: [],
      squareFeet: [],
      tags: []
    },
    tags: [],
    isOnlyEditable: false,
    showPopupAddEditListing: false
  }),

  watch: {
    async value(v) {
      if (v) {
        this.isLoading = true
        this.keyword = ''
        this.choseItems = []
        await this.fetchData()
        this.isLoading = false
      }
    }
  },

  methods: {
    roomInfo,
    formatRange(data, prefix = '') {
      return data.map(item => `${prefix}${item}`).join(' - ')
    },
    hide() {
      this.$emit('input', false)
    },
    async afterSaved(item) {
      await this.fetchData()
      if (item) {
        if (this.autoChoose) {
          this.chooseListing(item)
        } else {
          this.choseItems.push(item)
        }
      }
    },
    chooseListing(item) {
      if (!this.multiple) {
        this.$emit('choose', item)
        this.hide()
      } else if (!this.selectedIds.includes(item._id)) {
        const idx = this.choseItems.findIndex(ci => ci._id === item._id)
        if (idx === -1) {
          this.choseItems.push(item)
        } else {
          this.choseItems.splice(idx, 1)
        }
      }
    },
    save() {
      if (Array.isArray(this.choseItems) && this.choseItems.length) {
        this.$emit('choose', this.choseItems)
      }
      this.hide()
    },
    updateFilter(key, value) {
      this.$set(this.filter, key, value)
      this.fetchData()
    },
    async fetchData() {
      try {
        const params = {
          keyword: this.keyword,
          ...this.filter
        }
        const { data, ...options } = await this.$axios.$get('/listings/library', { params })
        this.listings = data
        this.options = { ...this.options, ...options }
      } catch (error) {
        this.$notify.error({
          title: 'Listing',
          message: this.$helpers.apiErrorMessage(error)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.popup-listing-library {
  .bg-action-note {
    border: 1px solid #FF8B02;
    background: rgba(255, 139, 2, 0.1);
  }
  .action-note-desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
    letter-spacing: 0.0025em;
  }
  .text-address {
    font-size: 11px;
    line-height: 21px;
    letter-spacing: 0.0025em;
  }
  .text-title {
    font-weight: bold;
    font-size: 13px;
    line-height: 16px;
    letter-spacing: 0.001em;
    text-transform: uppercase;
  }
  .text-type {
    font-weight: 500;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.001em;
  }
  .text-room {
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.0025em;
  }
  .listing-item {
    transition: all 0.15s ease-in-out;
    .absolute-0-0 {
      right: 0;
      top: 0;
      z-index: 2;
    }
    .selected-icon {
      display: none;
    }
  }
  .listing-selected .selected-icon {
    display: block;
  }
  .btn-filter {
    &::before {
      display: none;
    }
    &.v-text-field--outlined fieldset {
      border-color: rgba(0, 0, 0, 0.87) !important;
      border-width: 1px !important;
    }
  }
}
</style>
